
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Chess Championship</h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img
            src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm devaki-pandit section-banner-bg-1">
    <div class="container">

        <div class="row">
            <div class="col-lg-12">
                <div class="sec-title text-center">
                    <h4>Nagpur District Under 17 Open &amp;
                        Girls Selection Chess
                        Championship 2023 <span > 19<sup>th</sup>
                            March 2023 </span></h4>
                </div>

                <p>
                <p>Arush Chitre &amp; Shraddha Bajaj wins Nagpur District
                    Under 17 Open

                    &amp; Girls Selection Chess Championship 2023 </p>

                <p>Nagpur District Under 17 Open &amp; Girls Selection Chess
                    Championship 2023 concluded on 19 March 2023, at
                    Vivekananda
                    Hall, Shradhha House ,Kingsway ,Shri Mohini Complex
                    ,Nagpur.
                    Chess Association Nagpur organized the event in
                    Association with
                    GH Raisoni Sports and Cultural Foundation &amp; Kalpana
                    Prakash
                    Welfare Foundation. The tournament attracted 44 players
                    in open

                    category &amp; 18 Players in Girls category. </p>

                <p>21 International FIDE rated players in Open category
                    &amp; 5 International
                    FIDE rated players in Girls category Participated in the
                    tournament.
                    Arush Chitre won the championship in open section with
                    6.5 points
                    out of possible 7 . Shraddha Bajaj won the championship
                    in Girls
                    section with 4.5 points out of possible 5 .Total 10
                    trophies &amp; 24
                    medals were given to winners in different categories.
                </p>

                <p>1st Round Started at 10:AM.Prize Distribution ceremony
                    was held at
                    3:30M.Prizes were distributed by the hands of Chief
                    Guest Shri
                    .Swapnil Ahirkar (Joint Secertary) NCP Business
                    Cell,Social worker
                    and Director of Ahirkar Group , Other dignitaries
                    present were
                    Shri.Bhushan Shriwas Secretary Chess Association Nagpur
                    &amp;
                    Kalpana Prakash Welfare Foundation &amp; IA Deepak
                    Chavan.
                    Venue was Provided by Raisoni Group,Logistic Support for
                    the
                    tournament such as Chess Sets &amp; Chess clocks were
                    provided by
                    Chess Association Nagpur &amp; Kalpana Prakash Welfare
                    foundation. </p>

                <p>Chess results links and Final rank excel Sheet attached
                    in the mail. </p>

                <p>The team of Arbiters was headed by Chief Arbiter by IA
                    Deepak
                    Chavan and he was ably assisted by SNA Prayas Ambade
                    &amp; SNA
                    Sagar Sakhare &amp; Prathamesh Macchave worked hard to
                    make the

                    event a grand success. </p>

            </div>

        </div>
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col">
                <div class="widget_title inner-title">
                    <h4 class="fw-bold">Media Coverage</h4>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-chess-1.jpg"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-chess-1.jpg">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-chess-1.jpg"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-chess-2.jpg"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-chess-2.jpg">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/media-chess-2.jpg"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

            </div>

            <div class="col">
                <div class="row">
                    <div class="col-md-7">
                        <div class="widget_title inner-title">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess1.jpg"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess1.jpg">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess1.jpg"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess1.jpg"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess1.jpg">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/chess1.jpg"
                                    alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img
                                        src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>

                    </ul>
                </div>

            </div>

        </div>
    </div>

</section>
